import { bool, func, object, string } from 'prop-types';
import React from 'react';
import { Accordion, Button } from 'react-bootstrap';
const AccordionToggle = props => {
    AccordionToggle.propTypes = {
        clause: object,
        classificationName: string,
        isToggled: bool,
        onClickClauseSection: func,
    };
    const { clause, classificationName, isToggled, onClickClauseSection, } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(Accordion.Toggle, { as: Button, variant: 'link', className: 'expand-toggle-button', eventKey: classificationName, onClick: onClickClauseSection },
            React.createElement("div", { className: `accordion-clause-item ${isToggled ? 'selected' : ''}` },
                React.createElement("div", { className: 'accordion-clause-item-category' }, isToggled ? clause.category : clause.displayName),
                React.createElement("div", { className: 'toggle-icons', key: `${clause.id}-${isToggled}` },
                    React.createElement("i", { className: !isToggled ? 'fal fa-angle-up' : 'fal fa-angle-down' }))))));
};
export default AccordionToggle;
